<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Input Banner Mobile</h5>
            </template>
            <b-form @submit.prevent="$bvModal.show('modal-confirm')">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Judul">
                        <b-form-input v-model="input.judul" maxlength="255" required />
                    </b-form-group>
                    <b-form-group label="Teks">
                        <b-form-textarea v-model="input.teks" maxlength="2000" rows="4" max-rows="8" required />
                        <template v-slot:description>
                            <div class="small text-muted">
                                {{ input.teks.length }} / 2000 karakter
                            </div>
                        </template>
                    </b-form-group>
                    <b-form-group label="Foto Banner">
                        <b-form-file v-model="input.photo" accept="image/*" required />
                    </b-form-group>
                    <b-form-group label="Tautan / Link Tambahan (Opsional)" description="Tambahan tautan untuk navigasi pengguna selanjutnya (contoh: website PGI)">
                        <b-form-input v-model="input.link" maxlength="255" />
                    </b-form-group>
                    <b-button type="submit" variant="pgiBtn">
                        Simpan
                    </b-button>
                </div>
            </b-form>
        </b-card>
        <b-modal id="modal-confirm" title="Konfirmasi" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Tambahkan banner baru dengan judul "{{ input.judul }}"?
            <b-alert variant="primary" class="mt-4" show>
                <strong>INFORMASI</strong>
                <div class="mt-2">
                    Banner baru dapat diaktifkan pada halaman daftar / list banner mobile.
                </div>
            </b-alert>
            <div class="text-right mt-4">
                <b-button variant="pgiBtn" :disabled="isSubmitting" @click="execCreateBanner">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'banner-mobile-create',
    data() {
        return {

            isSubmitting: false,
            
            input: {
                judul: "",
                teks: "",
                photo: null,
                link: ""
            }

        }
    },
    methods: {

        execCreateBanner() {

            let payload = new FormData()
            payload.append("judul", this.input.judul)
            payload.append("teks", this.input.teks)
            payload.append("photo", this.input.photo)
            
            if(!this.$helper.isNullOrEmpty(this.input.link)) {
                payload.append("link", this.input.link)
            }

            this.isSubmitting = true
            this.$axios.post("banner-mobile/", payload).then(res => {
                this.$helper.setFlash("Banner berhasil dibuat!")
                this.$router.push("/master/banner-mobile/" + res.data.id)
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },  

    }
}
</script>